/**
 * One-click copy helpers for checkout delivery fields (Basic plan workaround).
 */
(function initCartDeliveryCopy() {
  /** @param {string} fullName */
  function splitName(fullName) {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
      return { firstName: '', lastName: '' };
    }
    if (parts.length === 1) {
      return { firstName: parts[0], lastName: '.' };
    }
    return {
      firstName: parts[0],
      lastName: parts.slice(1).join(' '),
    };
  }

  /**
   * @param {DOMStringMap} dataset
   */
  function readDeliveryData(dataset) {
    return {
      recipientName: dataset.recipientName || '',
      recipientPhone: dataset.recipientPhone || '',
      streetAddress: dataset.streetAddress || '',
      district: dataset.district || '',
      location: dataset.location || '',
      deliveryDay: dataset.deliveryDay || '',
      deliveryTime: dataset.deliveryTime || '',
    };
  }

  /**
   * @param {ReturnType<typeof readDeliveryData>} data
   */
  function buildCheckoutFields(data) {
    const { firstName, lastName } = splitName(data.recipientName);
    const address2 = [data.district, data.location, data.deliveryDay, data.deliveryTime]
      .filter(Boolean)
      .join(' · ');

    return {
      firstName,
      lastName: lastName || '.',
      address1: data.streetAddress,
      address2,
      city: 'Kayseri',
      zip: '38000',
      phone: data.recipientPhone,
    };
  }

  /**
   * @param {ReturnType<typeof buildCheckoutFields>} fields
   */
  function buildFullCopyText(fields) {
    const lines = [
      `Ad: ${fields.firstName}`,
      `Soyad: ${fields.lastName}`,
      fields.address1 ? `Adres: ${fields.address1}` : null,
      fields.address2 ? `Adres satırı 2: ${fields.address2}` : null,
      `Şehir: ${fields.city}`,
      `Posta kodu: ${fields.zip}`,
      fields.phone ? `Telefon: ${fields.phone}` : null,
    ].filter(Boolean);

    return lines.join('\n');
  }

  /**
   * @param {ReturnType<typeof buildCheckoutFields>} fields
   */
  function buildPreviewHtml(fields) {
    const rows = [
      ['Ad', fields.firstName],
      ['Soyad', fields.lastName],
      ['Adres', fields.address1],
      fields.address2 ? ['Adres satırı 2', fields.address2] : null,
      ['Şehir', fields.city],
      ['Posta kodu', fields.zip],
      fields.phone ? ['Telefon', fields.phone] : null,
    ].filter(Boolean);

    return rows
      .map(([label, value]) => {
        if (!value) return '';
        return `<div class="cart-delivery-summary__preview-row"><span>${label}</span><span>${escapeHtml(
          value
        )}</span></div>`;
      })
      .join('');
  }

  /** @param {string} value */
  function escapeHtml(value) {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /**
   * @param {string} text
   */
  async function copyToClipboard(text) {
    if (!text) {
      throw new Error('empty');
    }

    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  /**
   * @param {HTMLElement} button
   * @param {string} defaultLabel
   */
  function showCopied(button, defaultLabel) {
    const label = button.querySelector('.cart-delivery-summary__copy-label');
    if (!label) return;

    button.classList.add('is-copied');
    label.textContent = 'Kopyalandı ✓';

    window.setTimeout(() => {
      button.classList.remove('is-copied');
      label.textContent = defaultLabel;
    }, 2000);
  }

  /** @param {HTMLElement} root */
  function hydrateSummary(root) {
    if (root.dataset.copyReady === 'true') return;

    const data = readDeliveryData(root.dataset);
    const fields = buildCheckoutFields(data);
    const preview = root.querySelector('[data-delivery-preview]');
    if (preview) {
      preview.innerHTML = buildPreviewHtml(fields);
    }

    root.dataset.copyReady = 'true';
    root.dataset.copyAll = buildFullCopyText(fields);
    root.dataset.copyFirstName = fields.firstName;
    root.dataset.copyLastName = fields.lastName;
    root.dataset.copyAddress1 = fields.address1;
    root.dataset.copyPhone = fields.phone;
  }

  function hydrateAll() {
    document.querySelectorAll('.cart-delivery-summary[data-recipient-name]').forEach(hydrateSummary);
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[data-copy-key]');
    if (!(button instanceof HTMLButtonElement)) return;

    const root = button.closest('.cart-delivery-summary');
    if (!(root instanceof HTMLElement)) return;

    hydrateSummary(root);

    const copyKey = button.dataset.copyKey;
    const text = copyKey ? root.dataset[copyKey] || '' : '';
    const defaultLabel = button.dataset.copyLabel || 'Kopyala';

    if (!text) return;

    copyToClipboard(text)
      .then(() => showCopied(button, defaultLabel))
      .catch(() => {
        const label = button.querySelector('.cart-delivery-summary__copy-label');
        if (label) {
          label.textContent = 'Kopyalanamadı';
          window.setTimeout(() => {
            label.textContent = defaultLabel;
          }, 2000);
        }
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAll);
  } else {
    hydrateAll();
  }

  document.addEventListener('cart:update', hydrateAll);
})();
